import {
    ZtTableHeaderType,
    ZtTableRow,
    ZtTableSortOrder,
} from './zt-table.model';

export const sortNumeric = <T extends ZtTableRow>(
    key: string,
    sortOrder: ZtTableSortOrder
): ((a: T, b: T) => number) => {
    return function (a: T, b: T): number {
        return sortOrder === ZtTableSortOrder.DESC
            ? Number(a[key as keyof T]) - Number(b[key as keyof T])
            : Number(b[key as keyof T]) - Number(a[key as keyof T]);
    };
};

export const sortString = <T extends ZtTableRow>(
    key: string,
    sortOrder: ZtTableSortOrder
): ((a: T, b: T) => number) => {
    return function (a: T, b: T): number {
        if (a[key as keyof T] === b[key as keyof T]) {
            return 0;
        }

        return sortOrder === ZtTableSortOrder.DESC
            ? a[key as keyof T] > b[key as keyof T]
                ? 1
                : -1
            : a[key as keyof T] > b[key as keyof T]
            ? -1
            : 1;
    };
};

export const sortDate = <T extends ZtTableRow>(
    key: string,
    sortOrder: ZtTableSortOrder
): ((a: T, b: T) => number) => {
    return function (a: T, b: T): number {
        const aDate = new Date(a[key as keyof T] as unknown as Date);
        const bDate = new Date(b[key as keyof T] as unknown as Date);

        return sortOrder === ZtTableSortOrder.DESC
            ? aDate.getTime() - bDate.getTime()
            : bDate.getTime() - aDate.getTime();
    };
};

export const sortMap = new Map<ZtTableHeaderType, Function>([
    [ZtTableHeaderType.NUMBER, sortNumeric],
    [ZtTableHeaderType.STRING, sortString],
    [ZtTableHeaderType.STRING_VARIANTS, sortString],
    [ZtTableHeaderType.DATE, sortDate],
]);
